import { FileQuestionIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Paragraph } from '@/modules/ui/components/paragraph/Paragraph';
import { useCurrentUserQuery } from '@/modules/users/queries/useCurrentUserQuery';

import { ErrorPage } from './ErrorPage';

export const NotFound = () => {
  const currentUserQuery = useCurrentUserQuery();

  const isLoggedIn = currentUserQuery.isSuccess && currentUserQuery.data;

  const message = (
    <Paragraph>
      {isLoggedIn ? (
        <>
          The page you&apos;re looking for doesn&apos;t exist. <br /> Please
          check the URL or go to the{' '}
          <Link className="text-primary" to="/">
            jobs page.
          </Link>
        </>
      ) : (
        <>
          The page you&apos;re looking for doesn&apos;t exist. <br /> Please
          check the URL or{' '}
          <Link className="text-primary" to="/login">
            sign in.
          </Link>
        </>
      )}
    </Paragraph>
  );

  return (
    <ErrorPage
      icon={
        <FileQuestionIcon className="text-muted-foreground mb-4 h-16 w-16" />
      }
      title="Page Not Found"
      message={message}
    />
  );
};
